<footer id="master-footer" class="footer">
	<div class="container" style="padding: 0;">

        <ul>
            <li>
                @if(s_full()) {
                    <img class="logo" src="assets/logos/newfight/newfight-club-300.png" />
                }
            </li>
            <li>
                <h4>Vila Olímpia • São Paulo </h4>
                
                <p>
                    Rua Casa do ator, 1110 <br/>
                </p>
            </li>
            <li class="social">
                <h4>SIGA A NF</h4>
                
                <a href="https://www.facebook.com/Academia-New-Fight-677449039130834"
                    target="_blank">
                    <img class="social" src="assets/social/facebook-f.png" />
                </a>
                <a href="https://www.instagram.com/nfperformanceclub/" 
                    target="_blank">
                    <img class="social" src="assets/social/instagram-square.png" />
                </a>
            </li>
            <li>
                <h4>&copy; New Fight Performance Club</h4>
                <p>
                    <small>Todos os direitos reservados.</small> <br/>
                </p>
            </li>
        </ul>
        
    </div>
</footer> 
